import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button, Card } from '@mui/material';
import { renderSelect } from '../../Services/config/globals';
import {
  linkValidation, renderField, required, requiredSelect
} from '../../common/helpers/form-validations';
import categoriesDropDownList from '../Categories/categoriesDropDownList';
import { statusOptions } from './RequestStartUpList';
import { renderSelectForPlan } from '../UserMaster/StartUpForm';
import styles from '../UserDetails/MyProfile.module.css';

function RequestStartUpForm(props) {
  const {
    handleSubmit, onSubmit, mainText, SubmitText,
    invalid, pristine, action, submitSucceeded, editData
  } = props;

  return (
    <form
      form="ServiceProviderForm"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="row">
        <h6>{mainText}</h6>
        <span style={{ marginBottom: '15px', fontSize: '15px' }}>{action === 'add' ? 'Request for new Service Partners' : ''}</span>
        {action === 'edit' && (
          <Card className="product-detail-card" sx={{ margin: '0px 55px 30px 15px' }}>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-7 col-xl-8 col-xxl-9">
                <div className="pro-image-link-box-con pro-image-link-box-big">
                  <div className="pro-image-link-box-text">
                    <div className={`${styles['info-list-ul']}`} style={{ padding: '20px' }}>
                      <ul>
                        <li>
                          <strong>Start Up Name</strong> : {editData?.userView?.name}
                        </li>
                        <li>
                          <strong>Founder Name</strong> : {editData?.userView?.founderName}
                        </li>
                        <li>
                          <strong>Contact No</strong> : {editData?.userView?.mobile}
                        </li>
                        <li>
                          <strong>Email ID</strong> : {editData?.userView?.email}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        )}
        <div className="col-sm-12 col-md-12 col-lg-6">
          <div className="form-group">
            <label htmlFor="servicecategory">
              Partner Category <span className="validation-icon">*</span>
            </label>
            <Field
              type="dropdown"
              name="serviceCategory"
              placeholder="-- select one --"
              id="servicecategory"
              className="form-control"
              component={renderSelect}
              validate={[requiredSelect]}
              options={categoriesDropDownList()}
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6" />
        <div className="col-sm-12 col-md-12 col-lg-6">
          <div className="form-group">
            <label htmlFor="servicePartnerName">
              Requested Partner Name <span className="validation-icon">*</span>
            </label>
            <Field
              component={renderField}
              type="text"
              name="servicePartnerName"
              validate={[required]}
              id="servicePartnerName"
              className="form-control"
              placeholder="Enter name"
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <div className="form-group">
            <label htmlFor="web">
              Requested Partner Website <span className="validation-icon">*</span>
            </label>
            <Field
              component={renderField}
              type="text"
              name="websiteURL"
              validate={[required, linkValidation]}
              id="web"
              className="form-control"
              placeholder="https://"
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <div className="form-group">
            <label htmlFor="contactDetails">
              Contact Details, if any <span className="validation-icon">*</span>
            </label>
            <Field
              component={renderField}
              validate={[required]}
              type="textarea"
              name="contactDetails"
              id="contactDetails"
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <div className="form-group">
            <label htmlFor="remark">Remarks</label>
            <Field
              component={renderField}
              type="textarea"
              name="remark"
              id="remark"
              className="form-control"
              placeholder={`- For any queries pertaining to existing partners, please write to Partner POC, keeping CIIE.CO cc'd at seed.ciie@iima.ac.in\r\n
- For any other support pertaining to CIIE.CO, please write to us at seed.ciie@iima.ac.in`}
            />
          </div>
        </div>
        {action === 'edit' && (
          <div className="col-sm-3 col-md-3 col-lg-3">
            <div className="form-group">
              <label htmlFor="status">Status</label>
              <Field
                type="dropdown"
                name="status"
                placeholder="-- select one --"
                id="status"
                className="form-control"
                component={renderSelectForPlan}
                validate={[requiredSelect]}
                options={statusOptions}
              />
            </div>
          </div>
        )}
        <div className="form-group">
          <Button
            className="btn btn-red"
            type="submit"
            disabled={invalid || pristine || submitSucceeded}
          >
            {SubmitText}
          </Button>
        </div>
      </div>
    </form>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'requestStartUpForm'
});

export default withForm(RequestStartUpForm);
